import { atom, computed, type ReadableAtom } from 'nanostores'

export class ActionsStore<E extends HTMLElement = HTMLElement> {
	openId: ReadableAtom<string>
	trigger = atom<E | null>(null)

	constructor({
		getValue
	}: {
		getValue: (trigger: E | null) => string
	}) {
		this.openId = computed(this.trigger, getValue)
	}

	close() {
		this.trigger.set(null)
	}

	toggleTrigger(element: E | null) {
		const isSame = this.trigger.value === element
		this.trigger.set(isSame ? null : element)
	}
}
